// TODO: HVT-7537 After HVS reaches EOL, remove vault-secrets ability
import BaseAbility from './base-ability';
import {
  ACTION_GET_IAM_POLICY,
  ACTION_SET_IAM_POLICY,
  PREFIX_VAULT_SECRETS,
  SECRETS_APP,
} from '../utils/permission-types/index';
import { PermissionScope } from '../services/permissions';
import { variation } from 'ember-launch-darkly';

export default class VaultSecretsAppAbility extends BaseAbility {
  prefix = `${PREFIX_VAULT_SECRETS}.${SECRETS_APP}`;

  get canList() {
    if (variation('hvs-eos-eol')) {
      return (
        this.model?.billing?.hasFlexPayment ||
        this.model?.billing?.hasContractPayment ||
        this.model?.secretsApps?.length
      );
    }

    return true;
  }

  get canGetIamPolicy() {
    const permission = this.generate(ACTION_GET_IAM_POLICY);
    const hasResourcePermissions = (this.allowedPermissions ?? []).includes(
      permission,
    );
    const hasOrganizationPermissions = this.permissions.has(
      permission,
      PermissionScope.ORGANIZATION,
    );
    return hasResourcePermissions || hasOrganizationPermissions;
  }

  get canSetIamPolicy() {
    const permission = this.generate(ACTION_SET_IAM_POLICY);
    const hasResourcePermissions = (this.allowedPermissions ?? []).includes(
      permission,
    );
    const hasOrganizationPermissions = this.permissions.has(
      permission,
      PermissionScope.ORGANIZATION,
    );
    return hasResourcePermissions || hasOrganizationPermissions;
  }
}
